export default "__VITE_ASSET__DEqcbash__"